import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7zw5fdpzh: FaireProductEntity = {
  token: "p_e7zw5fdpzh",
  type: "product",
  name: "Kids Relax & Calm Patch - Natural Stress Relief & Relaxation",
  brandToken: "b_6gwiq2eawl",
  brandName: "PatchAid",
  imageUrl:
    "https://cdn.faire.com/fastly/551de36087485d7648f2c00256a2a01ba173bd625d1cb365b3ee4ee4cae00294.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e76b10167204723a38dafb14f8f68edb99bb646206dc93ab593c5a4ca17eee39.png",
    "https://cdn.faire.com/fastly/1b66ee5c67f22b63a973b151b076d135c78f9b32661f0f2950eb7ad0b7966139.png",
    "https://cdn.faire.com/fastly/d686c3a524886e760ccf7041f7321197c33fa7a250f62a79dc9ad54f11f4f6f9.png",
    "https://cdn.faire.com/fastly/785cbfa0dec57c5840c3a77c34efbc9866065847b4d93abe4e28aec729625446.png",
  ],
  priceDollars: 109.78,
  description:
    "The Kids Relax & Calm Patch by PatchAid is specially formulated with a blend of vitamins, minerals, and adaptogenic herbs to help promote relaxation and emotional balance. Designed for children’s sensitive skin, this patch is an ideal solution for parents seeking natural, non-pill calming support. With no artificial dyes or common irritants, it’s a strong performer in wellness, pharmacy, and children’s health categories.\n\nAvailable in Two Sizes:\n\n1-Pack: Each pack contains 30 patches and is priced at $8.99. Great for counters or floor displays and a top seller among parents looking for gentle stress support.\n\n12-Pack Display Case: Includes 12 packs for the price of 11. You’ll pay $98.89 for the set, with a free branded display case to boost visibility and margins.\n\nKey Benefits:\n• Includes B Vitamins, Magnesium, and Zinc for stress relief\n• With Ashwagandha, Rhodiola, and Passion Flower\n• Free from artificial dyes, colors, and common allergens",
  tags: [],
  msrpDollars: 299.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:08.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
